declare global {
  interface Window {
    embeddedservice_bootstrap?: {
      settings: Record<string, unknown>
      init: (orgId: string, name: string, eswLink: string, options: { scrt2URL: string }) => void
    }
  }
}

export const useAgentForceIntegration = (): void => {
  const { info, error } = useLogger('integrations/agentforce')

  const {
    public: {
      agentforce: {
        orgId = undefined,
        name = 'Agentforce_Web',
        eswLink = undefined,
        scrtUrl = undefined,
      },
    },
  } = useRuntimeConfig()

  if (!orgId || !name || !eswLink || !scrtUrl) {
    info('Agentforce Salesforce Embedded Messaging is not configured. Skipping Agentforce integration.')

    return
  }

  const initialized = useState('agentforceInitialized', () => false)

  const init = (): void => {
    if (initialized.value) {
      return
    }

    info('Initializing Agentforce Embedded Messaging')
    try {
      if (!window?.embeddedservice_bootstrap) {
        throw new Error('Embedded Messaging is not available')
      }

      window.embeddedservice_bootstrap.settings.language = 'en_US'
      window.embeddedservice_bootstrap.init(
        orgId,
        name,
        eswLink,
        {
          scrt2URL: scrtUrl,
        },
      )

      initialized.value = true
    }
    catch (err: unknown) {
      error('Error loading Embedded Messaging: ', err)
    }
  }

  onMounted(async () => {
    init()
  })
}
